import { APP_FEATURE_KEY, AppState } from '@cmi/store/app';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectAppState = createFeatureSelector<AppState>(APP_FEATURE_KEY);

export const selectAppCompanyLogo = createSelector(selectAppState, (state) => state.companyLogo);
export const selectAppNavLocation = createSelector(selectAppState, (state) => state.navLocation);
export const selectAppNavRoot = createSelector(selectAppState, (state) => state.navRoot);
export const selectAppHeight = createSelector(selectAppState, (state) => state.height);
